import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';

export default function AnalysisNavButton(props) {
  const {
    triggered,
    onTrigger,
  } = useNavAction('Analysis', props);

  return (
    <FocusableButton {...ex(['NavButton', 'AnalysisNavButton', { triggered }], props)} {...{ onClick: onTrigger() }}>
      {T('일별 분석 데이터')}
    </FocusableButton>
  );
}
